import React from "react";
import { motion } from "framer-motion";
import { Monitor, Activity, Brain, Bell, Users, Shield, Zap } from "lucide-react";

const features = [
  {
    title: "Real-time Patient Monitoring",
    description: "Continuous monitoring of vital signs with instant alerts for healthcare providers.",
    icon: Monitor,
    styleClass: "f-large",
    gradientClass: "g-blue"
  },
  {
    title: "Advanced Sensor Technology",
    description: "Medical-grade sensors for accurate readings.",
    icon: Activity,
    styleClass: "f-normal",
    gradientClass: "g-green"
  },
  {
    title: "AI/ML Health Analytics",
    description: "Predictive analytics for early intervention.",
    icon: Brain,
    styleClass: "f-normal",
    gradientClass: "g-purple"
  },
  {
    title: "Smart Alerts & Notifications",
    description: "Intelligent alert system for critical situations with customizable thresholds.",
    icon: Bell,
    styleClass: "f-normal",
    gradientClass: "g-orange"
  },
  {
    title: "Patient Portal",
    description: "Easy access for patients to view their health data.",
    icon: Users,
    styleClass: "f-normal",
    gradientClass: "g-indigo"
  },
  {
    title: "Doctor Dashboard",
    description: "Comprehensive dashboard for healthcare professionals.",
    icon: Shield,
    styleClass: "f-normal",
    gradientClass: "g-teal"
  }
];

const BentoFeaturesSection = () => {
  return (
    <section id="features" className="features-section">
      <div className="container">
        <motion.div
          className="md-section-header"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <h2>Comprehensive Healthcare Monitoring</h2>
          <p>Our IoT healthcare system provides end-to-end monitoring solutions with cutting-edge technology</p>
        </motion.div>

        <div className="bento-grid">
          {features.map((f, idx) => {
            const Icon = f.icon;
            return (
              <motion.div
                key={f.title}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: idx * 0.08 }}
                className={`feature-card ${f.styleClass}`}
              >
                <div className={`feature-icon ${f.gradientClass}`}>
                  <Icon />
                </div>
                <h3 className="feature-title">{f.title}</h3>
                <p className="feature-desc">{f.description}</p>

                {f.styleClass === "f-large" && (
                  <div className="progress-block">
                    <div className="meta-row">
                      <span>Accuracy</span><span className="meta-value"> 99.8%</span>
                    </div>
                    <div className="progress">
                      <div className="progress-fill full" />
                    </div>

                    <div className="meta-row">
                      <span>Response Time</span><span className="meta-value"> &lt; 100ms</span>
                    </div>
                    <div className="progress">
                      <div className="progress-fill high" />
                    </div>
                  </div>
                )}
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default BentoFeaturesSection;
